import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Container, Image } from "react-bootstrap";
import { IdTokenData } from "../components/DataDisplay";
import {
  BuildingOfficeIcon,
  ChevronDownIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

import {
  CheckBadgeIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/solid";
import TextInput from "../components/Input";
import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Button,
  Card,
  Checkbox,
  Input,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Option,
  Select,
  Typography,
} from "@material-tailwind/react";
import ContentLoader from "react-content-loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useAppDispatch } from "../hooks/app";
import { getAllApplications } from "../redux/actions/application";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { validateEmailId } from "../utils";
import { isEmpty, set } from "lodash";
import HSDialog from "../components/Dialog";
import {
  createOrgnization,
  resetCreateOrgFlag,
} from "../redux/actions/orgnization";
// import countryList from "react-select-country-list";
import countryList from "../utils/countrylist.json";
import HSSelect from "../components/Select";
import {
  ORGNIZATION_LEVEl,
  ORGNIZATION_PROGRAM_TYPE,
  ORGNIZATION_REGION,
  SUBSCRIPTION_TYPE,
} from "../utils/constant";
import moment from "moment-timezone";
import { fetchAllServiceCenters } from "../redux/actions/globalServiceCenterActions";

export const CreateOrgnization = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [address1, setAddress1] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  const [address2, setAddress2] = useState("");
  const [contactPersonName, setContactPersonName] = useState("");
  const [contactPersonNameError, setContactPersonNameError] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [country, setCountry] = useState<any>(undefined);
  const [countryError, setCountryError] = useState("");
  const [region, setRegion] = useState<any>(undefined);
  const [regionError, setRegionError] = useState<any>("");
  const [level, setLevel] = useState<any>(undefined);
  const [levelError, setLevelError] = useState("");
  const [programType, setProgramType] = useState<any>(undefined);
  const [serviceCenterRequired, setServiceCenterRequired] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [serviceCenterRequiredError, setServiceCenterRequiredError] =
    useState("");

  const [programTypeError, setProgramTypeError] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");
  const [contact1, setContact1] = useState("");
  const [contact1Error, setConstact1Error] = useState<any>("");
  const [contact2, setContact2] = useState("");
  const [pincode, setPincode] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [alertDialog, showAlertDialog] = useState<boolean | null>(null);
  const [ccService, setCcService] = useState<Array<any>>([]);

  const [llService, setLlService] = useState<Array<any>>([]);
  const [caService, setCaService] = useState<Array<any>>([]);
  const [cuService, setCuService] = useState<Array<any>>([]);
  const [ckService, setCkService] = useState<Array<any>>([]);
  const [pqService, setPqService] = useState<Array<any>>([]);
  const [rsService, setRsService] = useState<Array<any>>([]);

  const application = useSelector((state: RootState) => state.application);
  const org = useSelector((state: RootState) => state.organization);
  const [applications, setApplications] = useState<Array<any>>([]);
  const [open, setOpen] = useState<number>(1);
  const [selectdApp, setSelectedApps] = useState<any>({});
  const [value, setValue] = useState<any>({
    startDate: null,
    endDate: null,
  });
  const { serviceCenters, loading } = useSelector(
    (state: RootState) => state.globalServiceCenter
  );
  const yes_no_options = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const dispatch = useAppDispatch();

  const handleValueChange = (newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getAllApplications());
  }, []);

  // useEffect(() => {
  //   dispatch(fetchAllServiceCenters());
  // }, [dispatch]);

  useEffect(() => {
    if (org.orgnizationCreated) {
      resetData();
      dispatch(resetCreateOrgFlag());
    }
  }, [org.orgnizationCreated]);

  const toggleHeader = (value: number) => {
    if (open === value) {
      handleOpen(-1);
    } else {
      handleOpen(value);
    }
  };
  const handleOpen = (value: number) => setOpen(open === value ? 0 : value);

  const addApplication = () => {
    const temAppList = [...applications];
    // initialApplication.id = temAppList.length + 1
    // temAppList.push(initialApplication);
    setApplications(temAppList);
  };

  const initialApplication = {
    id: 0,
    headerTitle: "",
    logo: "",
    applicationType: "",
    role: "",
    class: "",
    organization: "",
    code: "",
  };

  const onSelectOption = (menu: any, type: "DELETE" | "ADD") => {
    const temAppList = [...applications];
    if (type === "ADD" && isSelected(menu.applicationCode) === -1) {
      const menuData: any = menuList.find(
        (e) => e.applicationCode === menu.applicationCode
      );
      initialApplication.id = menu.applicationCode;
      initialApplication.headerTitle = menuData?.name || "";
      initialApplication.logo = menuData?.logo || "";
      initialApplication.code = menuData.applicationCode;

      let tempSelected: any = { ...selectdApp };
      if (
        tempSelected &&
        !tempSelected.hasOwnProperty(menuData.applicationCode)
      ) {
        tempSelected[menuData.applicationCode] = {
          startDate: undefined,
          endDate: undefined,
          license: "",
          applicationId: menu.id,
          subscription_type: { label: "Yearly", value: "Yearly" },
        };
      } else {
        tempSelected = {
          [menuData.applicationCode]: {
            startDate: undefined,
            endDate: undefined,
            license: "",
            applicationId: menu.id,
            subscription_type: { label: "Yearly", value: "Yearly" },
          },
        };
      }
      setSelectedApps(tempSelected);
      temAppList.push(initialApplication);
      setApplications(temAppList);
      handleOpen(applications.length);
    } else if (type === "DELETE") {
      temAppList.splice(isSelected(menu), 1);
      let tempSelected: any = { ...selectdApp };
      delete tempSelected[menu];
      setSelectedApps(tempSelected);
      setApplications(temAppList);
    }
  };

  const isSelected = (menuId: any) => {
    return applications.findIndex((element) => element.code == menuId);
  };

  const menuList = [
    {
      id: 1,
      name: "COR Advantage",
      logo: "/images/coreA.webp",
      applicationCode: "COR-A",
    },
    {
      id: 2,
      name: "COR FOR Kindergarten",
      logo: "/images/cork.webp",
      applicationCode: "COR-K",
    },
    {
      id: 3,
      name: "Classroom Coach",
      logo: "/images/classroomCoach.webp",
      applicationCode: "COR-C",
    },
    {
      id: 4,
      name: "Ready School Assessment",
      logo: "/images/logoRSA.webp",
      applicationCode: "COR-R",
    },
    {
      id: 6,
      name: "Letter Links",
      logo: "/images/letterLink.webp",
      applicationCode: "COR-L",
    },
    {
      id: 6,
      name: "Program Quality Assessment",
      logo: "/images/logoPQA.webp",
      applicationCode: "COR-P",
    },
    {
      id: 7,
      name: "Curriculum",
      logo: "/images/CurriculumNew.png",
      applicationCode: "COR-CU",
    },
  ];

  const onValunChange = (key: string, chiledkey: string, value: any) => {
    let tempSelected: any = { ...selectdApp };
    tempSelected[key][chiledkey] = value;
    delete tempSelected[key][chiledkey + "Error"];
    setSelectedApps(tempSelected);
  };

  const resetData = () => {
    setName("");
    setNameError("");
    setAddress1("");
    setAddress1Error("");
    setAddress2("");
    setPhone("");
    setPhoneError("");
    setCountry(null);
    setCountryError("");
    setRegion(null);
    setConstact1Error("");
    setRegionError("");
    setLevel("");
    setLevelError("");
    setProgramType("");
    setProgramTypeError("");
    setContactPersonName("");
    setContactPersonNameError("");
    setCity("");
    setCityError("");
    setState("");
    setStateError("");
    setContact1("");
    setContact2("");
    setPincode("");
    setPincodeError("");
    setEmail("");
    setEmailError("");
    showAlertDialog(null);
    setSelectedApps({});
    setApplications([]);
    setCcService([]);
    setLlService([]);
    setCaService([]);
    setCuService([]);
    setRsService([]);
    setCkService([]);
    setPqService([]);
    setServiceCenterRequired(null);
    setServiceCenterRequiredError("");
  };

  const onSubmit = () => {
    if (!name) {
      setNameError("Please enter name");
      return;
    }

    if (!contactPersonName) {
      setContactPersonNameError("Please enter contact person name");
      return;
    }

    if (!email) {
      setEmailError("Please enter email");
      return;
    }

    if (!validateEmailId(email)) {
      setEmailError("Please enter valid email");
      return;
    }

    if (!address1) {
      setAddress1Error("Please enter address");
      return;
    }

    if (!city) {
      setCityError("Please enter city");
      return;
    }

    if (!state) {
      setStateError("Please enter state");
      return;
    }

    if (!country) {
      setCountryError("Please select country");
      return;
    }

    if (!pincode) {
      setPincodeError("Please enter pincode");
      return;
    }

    if (!phone) {
      setPhoneError("Please enter phone");
      return;
    }

    if (phone && phone.length !== 10) {
      setPhoneError("Phone number must be 10 digit");
      return;
    }

    if (!contact1) {
      setConstact1Error("Please enter contact1");
      return;
    }

    if (!region) {
      setRegionError("Please select region");
      return;
    }

    if (!level) {
      setLevelError("Please select level");
      return;
    }

    if (!programType) {
      setProgramTypeError("Please select program type");
      return;
    }

    if (!serviceCenterRequired) {
      setServiceCenterRequiredError("Please select service center requirement");
      return;
    }
    // if (!selectdApp || isEmpty(selectdApp)) {
    //   showAlertDialog(true);
    //   return;
    // }

    const tempvalue = { ...selectdApp };
    let isErrorOccured = false;
    for (var key in selectdApp) {
      if (!tempvalue[key]?.license) {
        tempvalue[key]["licenseError"] = "Please enter license count";
        isErrorOccured = true;
      }

      if (!tempvalue[key]?.startDate) {
        tempvalue[key]["startDateError"] = "Please select start date";
        isErrorOccured = true;
      }

      if (!tempvalue[key]?.endDate) {
        tempvalue[key]["endDateError"] = "Please select end date";
        isErrorOccured = true;
      }

      if (!tempvalue[key]?.subscription_type) {
        tempvalue[key]["subscription_type_error"] =
          "Please select subscription type";
        isErrorOccured = true;
      }
    }

    const tempService = ccService;
    for (var service in ccService) {
      if (!tempService?.[service]?.globalServiceId) {
        tempService[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService?.[service]?.licenceNumber === "0") {
        tempService[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService?.[service]?.licenceNumber === "") {
        tempService[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (!tempService?.[service]?.startDate) {
        tempService[service]["startDateError"] = "Please Enter Start Date";
        isErrorOccured = true;
      }
      if (!tempService?.[service]?.expireDate) {
        tempService[service]["expireDateError"] = "Please Enter Expiry Date";
        isErrorOccured = true;
      }
    }

    const tempService2 = llService;
    for (var service in llService) {
      if (!tempService2?.[service]?.globalServiceId) {
        tempService2[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService2?.[service]?.licenceNumber === "0") {
        tempService2[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService2?.[service]?.licenceNumber === "") {
        tempService2[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (!tempService2?.[service]?.startDate) {
        tempService2[service]["startDateError"] = "Please Enter Start Date";
        isErrorOccured = true;
      }
      if (!tempService2?.[service]?.expireDate) {
        tempService2[service]["expireDateError"] = "Please Enter Expiry Date";
        isErrorOccured = true;
      }
    }

    const tempService3 = caService;
    for (var service in caService) {
      if (!tempService3?.[service]?.globalServiceId) {
        tempService3[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService3?.[service]?.licenceNumber === "0") {
        tempService3[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService3?.[service]?.licenceNumber === "") {
        tempService3[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
    }

    const tempService4 = ckService;
    for (var service in ckService) {
      if (!tempService4?.[service]?.globalServiceId) {
        tempService4[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService4?.[service]?.licenceNumber === "0") {
        tempService4[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService4?.[service]?.licenceNumber === "") {
        tempService4[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
    }

    const tempService5 = cuService;
    for (var service in cuService) {
      if (!tempService5?.[service]?.globalServiceId) {
        tempService5[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService5?.[service]?.licenceNumber === "0") {
        tempService5[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService5?.[service]?.licenceNumber === "") {
        tempService5[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (!tempService5?.[service]?.startDate) {
        tempService5[service]["startDateError"] = "Please Enter Start Date";
        isErrorOccured = true;
      }
      if (!tempService5?.[service]?.expireDate) {
        tempService5[service]["expireDateError"] = "Please Enter Expiry Date";
        isErrorOccured = true;
      }
    }

    const tempService6 = pqService;
    for (var service in pqService) {
      if (!tempService6?.[service]?.globalServiceId) {
        tempService6[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService6?.[service]?.licenceNumber === "0") {
        tempService6[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService6?.[service]?.licenceNumber === "") {
        tempService6[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
    }

    const tempService7 = rsService;
    for (var service in rsService) {
      if (!tempService7?.[service]?.globalServiceId) {
        tempService7[service]["name_error"] = "Please select Service Center";
        isErrorOccured = true;
      }
      if (tempService7?.[service]?.licenceNumber === "0") {
        tempService7[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
      if (tempService7?.[service]?.licenceNumber === "") {
        tempService7[service]["licenseError"] =
          "Please Enter number of licences";
        isErrorOccured = true;
      }
    }

    if (isErrorOccured) {
      setSelectedApps(tempvalue);
      setCcService(tempService);
      setLlService(tempService2);
      setCaService(tempService3);
      setCkService(tempService4);
      setCuService(tempService5);
      setPqService(tempService6);
      setRsService(tempService7);
    } else {
      const body: any = {
        name: name,
        address1: address1,
        address2: address2,
        phone: phone,
        state: state,
        contact1: contact1,
        contact2: contact2,
        pincode: pincode,
        emailId: email,
        country: country.name,
        country_code: country.code,
        country_dial_code: country.dial_code,
        level: level.label,
        programType: programType.label,
        region: region.label,
        contact_person_name: contactPersonName,
        city: city,
        requires_service_center:
          serviceCenterRequired?.value === "Yes" ? true : false,
      };
      const applications: any = [];
      for (var key in selectdApp) {
        const applicationObj = {
          applicationId: selectdApp[key]?.applicationId,
          license: selectdApp[key]?.license,
          // startDate: selectdApp[key]?.startDate.toISOString().split("T")[0],
          // expireDate: selectdApp[key]?.endDate.toISOString().split("T")[0],
          startDate: moment(selectdApp[key]?.startDate).format(
            "YYYY-MM-DD HH:mm:ss.SSSSSSS"
          ),
          expireDate: moment(selectdApp[key]?.endDate).format(
            "YYYY-MM-DD HH:mm:ss.SSSSSSS"
          ),
          subscription_type: selectdApp[key]?.subscription_type.label,
          code: key,
          // id: 25, Need to add for update
        };
        applications.push(applicationObj);
      }
      body["userApplications"] = applications;
      const corCData: any = [];
      for (var ser in ccService) {
        const serCObj = {
          applicationId: selectdApp["COR-C"]?.applicationId,
          globalServiceId: ccService[ser].globalServiceId,
          name: ccService[ser].serviceCenterName,
          license: ccService[ser].licenceNumber,
          startDate: ccService[ser].startDate,
          expireDate: ccService[ser].expireDate,
          isDelete: ccService[ser].isDelete,
          isActive: ccService[ser].isActive,
        };
        corCData.push(serCObj);
      }
      body["corCServices"] = corCData;

      const corLData: any = [];
      for (var ser in llService) {
        const serCObj = {
          applicationId: selectdApp["COR-L"]?.applicationId,
          globalServiceId: llService[ser].globalServiceId,
          name: llService[ser].serviceCenterName,
          license: llService[ser].licenceNumber,
          startDate: llService[ser].startDate,
          expireDate: llService[ser].expireDate,
          isDelete: llService[ser].isDelete,
          isActive: llService[ser].isActive,
        };
        corLData.push(serCObj);
      }
      body["corLServices"] = corLData;
      const corAData: any = [];
      for (var ser in caService) {
        const serCObj = {
          applicationId: selectdApp["COR-A"]?.applicationId,
          globalServiceId: caService[ser].globalServiceId,
          name: caService[ser].serviceCenterName,
          license: caService[ser].licenceNumber,
          isDelete: caService[ser].isDelete,
          isActive: caService[ser].isActive,
        };
        corAData.push(serCObj);
      }
      body["corCaServices"] = corAData;

      const corKData: any = [];
      for (var ser in ckService) {
        const serCObj = {
          applicationId: selectdApp["COR-K"]?.applicationId,
          globalServiceId: ckService[ser].globalServiceId,
          name: ckService[ser].serviceCenterName,
          license: ckService[ser].licenceNumber,
          isDelete: ckService[ser].isDelete,
          isActive: ckService[ser].isActive,
        };
        corKData.push(serCObj);
      }
      body["corCkServices"] = corKData;

      const corCuData: any = [];
      for (var ser in cuService) {
        const serCObj = {
          applicationId: selectdApp["COR-CU"]?.applicationId,
          globalServiceId: cuService[ser].globalServiceId,
          name: cuService[ser].serviceCenterName,
          license: cuService[ser].licenceNumber,
          startDate: cuService[ser].startDate
            ? moment(cuService[ser].startDate).format(
                "YYYY-MM-DD HH:mm:ss.SSSSSSS"
              )
            : null,
          expireDate: cuService[ser].expireDate
            ? moment(cuService[ser].expireDate).format(
                "YYYY-MM-DD HH:mm:ss.SSSSSSS"
              )
            : null,
          isDelete: cuService[ser].isDelete,
          isActive: cuService[ser].isActive,
        };
        corCuData.push(serCObj);
      }
      body["corCuServices"] = corCuData;

      const corPqaData: any = [];
      for (var ser in pqService) {
        const serCObj = {
          applicationId: selectdApp["COR-P"]?.applicationId,
          globalServiceId: pqService[ser].globalServiceId,
          name: pqService[ser].serviceCenterName,
          license: pqService[ser].licenceNumber,
          isDelete: pqService[ser].isDelete,
          isActive: pqService[ser].isActive,
        };
        corPqaData.push(serCObj);
      }
      body["corPqServices"] = corPqaData;

      const corRsaData: any = [];
      for (var ser in rsService) {
        const serCObj = {
          applicationId: selectdApp["COR-R"]?.applicationId,
          globalServiceId: rsService[ser].globalServiceId,
          name: rsService[ser].serviceCenterName,
          license: rsService[ser].licenceNumber,
          isDelete: rsService[ser].isDelete,
          isActive: rsService[ser].isActive,
        };
        corRsaData.push(serCObj);
      }
      body["corRServices"] = corRsaData;

      dispatch(createOrgnization(body));
    }
  };

  // selectedDate.toISOString().split('T')[0]
  const MyLoader = () => (
    <ContentLoader viewBox="0 0 380 26" className="rounded-lg">
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="60" />
    </ContentLoader>
  );

  const addCCService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      ccId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
      startDate: undefined,
      expireDate: undefined,
    };

    setCcService([...ccService, newTeacher]);
  };

  const addLLService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      llId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
      startDate: undefined,
      expireDate: undefined,
    };

    setLlService([...llService, newTeacher]);
  };

  const addCAService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      caId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
    };

    setCaService([...caService, newTeacher]);
  };

  const addCKService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      ckId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
    };

    setCkService([...ckService, newTeacher]);
  };

  const addCUService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      cuId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
      startDate: undefined,
      expireDate: undefined,
    };

    setCuService([...cuService, newTeacher]);
  };

  const addPQService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      pqId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
    };

    setPqService([...pqService, newTeacher]);
  };

  const addRSService = () => {
    const generateRandomId = () => {
      const randomId = Math.random().toString(36).substr(2, 9);
      return randomId;
    };

    const newTeacher: any = {
      rsId: generateRandomId(),
      globalServiceId: undefined,
      serviceCenterName: "",
      licenceNumber: "0",
      isActive: true,
      isDelete: false,
    };

    setRsService([...rsService, newTeacher]);
  };

  const deleteCCService = (service: any) => {
    const ccNew = ccService.filter((ser: any) => ser.ccId !== service.ccId);
    setCcService(ccNew);
  };

  const deleteLLService = (service: any) => {
    const llNew = llService.filter((ser: any) => ser.llId !== service.llId);
    setLlService(llNew);
  };

  const deleteCAService = (service: any) => {
    const caNew = caService.filter((ser: any) => ser.caId !== service.caId);
    setCaService(caNew);
  };

  const deleteCKService = (service: any) => {
    const ckNew = ckService.filter((ser: any) => ser.ckId !== service.ckId);
    setCkService(ckNew);
  };

  const deleteCUService = (service: any) => {
    const cuNew = cuService.filter((ser: any) => ser.cuId !== service.cuId);
    setCuService(cuNew);
  };

  const deletePQService = (service: any) => {
    const pqNew = pqService.filter((ser: any) => ser.pqId !== service.pqId);
    setPqService(pqNew);
  };

  const deleteRSService = (service: any) => {
    const rsNew = rsService.filter((ser: any) => ser.rsId !== service.rsId);
    setRsService(rsNew);
  };

  useEffect(() => {
    if (selectdApp && selectdApp["COR-C"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = ccService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-C"]) {
        tempSelected["COR-C"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [ccService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-L"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = llService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-L"]) {
        tempSelected["COR-L"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [llService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-A"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = caService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-A"]) {
        tempSelected["COR-A"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [caService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-K"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = ckService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-K"]) {
        tempSelected["COR-K"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [ckService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-CU"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = cuService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-CU"]) {
        tempSelected["COR-CU"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [cuService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-P"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = pqService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-P"]) {
        tempSelected["COR-P"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [pqService]);

  useEffect(() => {
    if (selectdApp && selectdApp["COR-R"]) {
      let tempSelected = { ...selectdApp };
      let totalLicenses = rsService
        .reduce((sum, service) => sum + parseInt(service.licenceNumber || 0), 0)
        .toString();
      if (tempSelected["COR-R"]) {
        tempSelected["COR-R"]["license"] = totalLicenses;
        setSelectedApps(tempSelected);
      }
    }
  }, [rsService]);

  return (
    <>
      {/* <AuthenticatedTemplate>
        {activeAccount ? ( */}
      <Container className="h-full bg-white p-4 min-w-[80vw] font-Popins overflow-auto">
        <div className="h-full res_height ">
          <div className="flex flex-row justify-center  bg-[#264390] max-w-[280px]  mx-auto text-white font-medium p-2 min-h-fit max-h-full rounded-sm ">
            <BuildingOfficeIcon className="w-8 h-8 mr-2 " />
            <span className="text-2xl font-medium ">Create Organization</span>
          </div>
          <div className="Card my-3 rounded-md shadow-sm bg-[#ececec]">
            <div className="p-4 xl:h-[57vh] 2xl:h-[65vh] 1xl:h-[58vh] lg:h-[55vh] md:h-[55vh] overflow-auto">
              <span className="font-semibold text-xl">
                Enter Organization Details
              </span>
              <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 px-1 py-3 gap-y-1 gap-x-5">
                <TextInput
                  label={"Name"}
                  placeholder={"Name"}
                  required={true}
                  value={name}
                  error={nameError}
                  onChange={(e: any) => {
                    setName(e.target.value);
                    setNameError("");
                  }}
                />
                <TextInput
                  label={"Contact Person Name"}
                  placeholder={"Contact Person Name"}
                  required={true}
                  value={contactPersonName}
                  error={contactPersonNameError}
                  onChange={(e: any) => {
                    setContactPersonName(e.target.value);
                    setContactPersonNameError("");
                  }}
                />

                <TextInput
                  label={"Contact Person Email"}
                  placeholder={"Contact Person Email"}
                  required={true}
                  error={emailError}
                  value={email}
                  onChange={(e: any) => {
                    setEmail(e.target.value);
                    setEmailError("");
                  }}
                />

                <TextInput
                  label={"Address 1"}
                  placeholder={"Address 1"}
                  required={true}
                  error={address1Error}
                  value={address1}
                  onChange={(e: any) => {
                    setAddress1(e.target.value);
                    setAddress1Error("");
                  }}
                />
                <TextInput
                  required={false}
                  label={"Address 2"}
                  placeholder={"Address 2"}
                  value={address2}
                  onChange={(e: any) => setAddress2(e.target.value)}
                />

                <TextInput
                  label={"City"}
                  placeholder={"City"}
                  required={true}
                  value={city}
                  error={cityError}
                  onChange={(e: any) => {
                    setCity(e.target.value);
                    setCityError("");
                  }}
                />

                <TextInput
                  label={"State"}
                  placeholder={"State"}
                  value={state}
                  error={stateError}
                  required={true}
                  onChange={(e: any) => {
                    setState(e.target.value);
                    setStateError("");
                  }}
                />

                <HSSelect
                  label={"Select Country"}
                  placeholder="Select Country *"
                  options={countryList.data}
                  required={true}
                  getOptionLabel={(option: any) => option.name}
                  getOptionValue={(option: any) => option.code}
                  value={country}
                  onChange={(obj: any) => {
                    setCountry(obj);
                    setCountryError("");
                    // onChangeUserDetails(obj, "organization");
                    // setOrgDetails(obj);
                  }}
                  error={countryError}
                />

                <TextInput
                  label={"Zip Code"}
                  placeholder={"Zip Code"}
                  required={true}
                  value={pincode}
                  error={pincodeError}
                  onChange={(e: any) => {
                    const re = /^[a-zA-Z0-9\b]+$/;
                    if (
                      (re.test(e.target.value) && e.target.value.length < 10) ||
                      !e.target.value
                    ) {
                      setPincode(e.target.value);
                      setPincodeError("");
                    }
                  }}
                />

                <TextInput
                  label={"Phone"}
                  placeholder={"Phone"}
                  required={true}
                  value={phone}
                  error={phoneError}
                  onChange={(e: any) => {
                    const re = /^[0-9\b]+$/;
                    if (
                      (re.test(e.target.value) && e.target.value.length < 11) ||
                      !e.target.value
                    ) {
                      setPhone(e.target.value);
                      setPhoneError("");
                    }
                  }}
                />
                {/* <TextInput
                  placeholder={"Country"}
                  required={true}
                  value={country}
                  error={countryError}
                  onChange={(e: any) => {
                    setCountry(e.target.value);
                    setCountryError("");
                  }}
                /> */}

                <TextInput
                  label={"Contact 1"}
                  required={true}
                  placeholder={"Contact 1"}
                  value={contact1}
                  onChange={(e: any) => {
                    setContact1(e.target.value);
                    setConstact1Error("");
                  }}
                  error={contact1Error}
                />
                <TextInput
                  required={false}
                  label={"Contact 2 "}
                  placeholder={"Contact 2"}
                  value={contact2}
                  onChange={(e: any) => {
                    setContact2(e.target.value);
                  }}
                />

                <HSSelect
                  label={"Select Region"}
                  required={true}
                  placeholder="Select Region *"
                  options={ORGNIZATION_REGION}
                  getOptionLabel={(option: any) => option.label}
                  getOptionValue={(option: any) => option.value}
                  value={region}
                  onChange={(obj: any) => {
                    setRegion(obj);
                    setRegionError("");
                    // onChangeUserDetails(obj, "organization");
                    // setOrgDetails(obj);
                  }}
                  error={regionError}
                />

                <HSSelect
                  label={"Select Level"}
                  required={true}
                  placeholder="Select Level *"
                  options={ORGNIZATION_LEVEl}
                  getOptionLabel={(option: any) => option.label}
                  getOptionValue={(option: any) => option.value}
                  value={level}
                  onChange={(obj: any) => {
                    setLevel(obj);
                    setLevelError("");
                  }}
                  error={levelError}
                />

                <HSSelect
                  label={"Select Program type"}
                  required={true}
                  placeholder="Select Program type *"
                  options={ORGNIZATION_PROGRAM_TYPE}
                  getOptionLabel={(option: any) => option.label}
                  getOptionValue={(option: any) => option.value}
                  value={programType}
                  onChange={(obj: any) => {
                    setProgramType(obj);
                    setProgramTypeError("");
                    // onChangeUserDetails(obj, "organization");
                    // setOrgDetails(obj);
                  }}
                  error={programTypeError}
                />
                <HSSelect
                  label={"Service Center Required"}
                  placeholder={"Service Center Required"}
                  options={yes_no_options}
                  required={true}
                  value={serviceCenterRequired}
                  error={serviceCenterRequiredError}
                  onChange={(e: any) => {
                    setServiceCenterRequired(e);
                    setServiceCenterRequiredError("");
                  }}
                />
              </div>

              {/* ------------------ Application Licence info ------------------- */}
              {serviceCenterRequired &&
                serviceCenterRequired.value === "No" && (
                  <div className="grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 px-1 py-3 gap-4">
                    <div />
                    <div />
                    {!application.appLoading ? (
                      <>
                        {application.appList.length < 8 && (
                          <Menu>
                            <MenuHandler>
                              <Button
                                className="  flex flex-row items-center  bg-[#264390]  p-2 h-[46px]"
                                size="sm"
                                onClick={() => addApplication()}
                              >
                                <ChevronDownIcon className="w-7 h-7 mr-2 " />
                                <span className="text-[15px] font-normal">
                                  Add Application Access
                                </span>
                              </Button>
                            </MenuHandler>

                            <MenuList
                              className={` p-0 w-[24%] relative  bg-[#264390] text-white boredr border-white rounded-none -mt-2 `}
                            >
                              {application.appList.map(
                                (menu: any, index: number) => (
                                  <MenuItem
                                    key={index}
                                    className={`border-b border-white rounded-none 
                      ${
                        isSelected(menu.applicationCode) === -1
                          ? " "
                          : "bg-gray-200 text-gray-600 rounded-none "
                      }`}
                                    onClick={() => onSelectOption(menu, "ADD")}
                                  >
                                    {menu.applicationName}
                                  </MenuItem>
                                )
                              )}
                            </MenuList>
                          </Menu>
                        )}
                      </>
                    ) : (
                      <MyLoader />
                    )}
                  </div>
                )}

              {serviceCenterRequired?.value === "No" &&
                applications.map((obj: any, index: number) => {
                  let isError = false;
                  let isCompleted = false;
                  if (
                    selectdApp[obj.code]?.licenseError ||
                    selectdApp[obj.code]?.startDateError ||
                    selectdApp[obj.code]?.endDateError ||
                    selectdApp[obj.code]?.subscription_type_error
                  ) {
                    isError = true;
                  } else {
                    if (
                      selectdApp[obj.code]?.license &&
                      selectdApp[obj.code]?.startDate &&
                      selectdApp[obj.code]?.endDate &&
                      selectdApp[obj.code]?.subscription_type
                    ) {
                      isCompleted = true;
                    }
                  }
                  return (
                    <Accordion
                      open={open === index}
                      className="mb-2 rounded-lg border border-blue-gray-100 text-center shadow-xl "
                    >
                      <AccordionHeader
                        onClick={() => toggleHeader(index)}
                        className={`bg-[#264390] text-white ${
                          open == index
                            ? "rounded-lg rounded-b-none"
                            : "rounded-lg "
                        } h-[40px]  flex justify-between`}
                      >
                        <div className=" w-full flex flex-row justify-between items-center">
                          <div className="flex flex-row items-center">
                            <p className="mt-3 px-4">{obj.headerTitle}</p>
                            {isError && (
                              <ExclamationCircleIcon
                                className="w-8 h-8"
                                color={"#f2382e"}
                              />
                            )}
                            {isCompleted && (
                              <CheckBadgeIcon
                                className="w-8 h-8"
                                color={"#07e015"}
                              />
                            )}
                          </div>
                          <div className=" flex flex-row">
                            <div className="flex text-white">
                              <PencilSquareIcon className="w-8 h-8 mr-3 bg-[#264390] p-1" />
                              <TrashIcon
                                className="w-8 h-8 bg-[#264390] p-1"
                                onClick={() => onSelectOption(obj.id, "DELETE")}
                              />
                            </div>
                            <ChevronDownIcon className="w-8 h-8 ml-2 items-end" />
                          </div>
                        </div>
                      </AccordionHeader>
                      <AccordionBody className="pt-0 text-base font-normal bg-white">
                        <div className="flex flex-row w-full items-center">
                          <Image
                            className="px-3 py-2"
                            src={obj.logo}
                            width={180}
                            height={72}
                            alt="COR Advantage"
                          />

                          <div className="grid grid-cols-4 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-4 px-5 py-3 w-full ">
                            <TextInput
                              placeholder="Licence"
                              required={true}
                              value={selectdApp[obj.code]?.license}
                              crossOrigin={undefined}
                              type="number"
                              label="Licence"
                              error={selectdApp[obj.code]?.licenseError}
                              disabled={
                                (obj.code === "COR-C" &&
                                  ccService.length > 0) ||
                                (obj.code === "COR-L" &&
                                  llService.length > 0) ||
                                (obj.code === "COR-A" &&
                                  caService.length > 0) ||
                                (obj.code === "COR-K" &&
                                  ckService.length > 0) ||
                                (obj.code === "COR-CU" &&
                                  cuService.length > 0) ||
                                (obj.code === "COR-P" &&
                                  pqService.length > 0) ||
                                (obj.code === "COR-R" && rsService.length > 0)
                              }
                              onChange={(e: any) => {
                                applications[index].role = e.target.value;
                                setApplications([...applications]);

                                onValunChange(
                                  obj.code,
                                  "license",
                                  e.target.value
                                );
                              }}
                            />
                            <div className="flex flex-col text-left">
                              <div className="w-full flex text-left">
                                <div className="text-red-600">*</div>
                                Start Date
                              </div>

                              <DatePicker
                                className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field"
                                selected={selectdApp[obj.code]?.startDate}
                                onChange={(date: any) => {
                                  onValunChange(obj.code, "startDate", date);

                                  const d = new Date(date);
                                  d.setFullYear(d.getFullYear() + 1);
                                  onValunChange(obj.code, "endDate", d);
                                }}
                                placeholderText="MM/DD/YYYY"
                                title={"Start Date"}
                                required={true}
                              />
                              {selectdApp[obj.code]?.startDateError ? (
                                <div className={"text-xs text-[#FF0000] flex"}>
                                  {selectdApp[obj.code]?.startDateError}
                                </div>
                              ) : (
                                <div className={"text-xs text-[#FF0000] h-4"} />
                              )}
                            </div>

                            <div className="flex flex-col">
                              <div className="w-full flex ">
                                <div className="text-red-600">*</div>
                                Subscription Type
                              </div>
                              <div className="-mt-6 ">
                                <HSSelect
                                  placeholder="Subscription Type*"
                                  options={SUBSCRIPTION_TYPE}
                                  getOptionLabel={(option: any) => option.label}
                                  getOptionValue={(option: any) => option.value}
                                  value={
                                    selectdApp[obj.code]?.subscription_type
                                  }
                                  onChange={(obj: any) => {}}
                                  error={
                                    selectdApp[obj.code]
                                      ?.subscription_type_error
                                  }
                                />
                              </div>
                            </div>

                            <div className="w-[100%] flex flex-col">
                              <div className="w-full flex ">
                                <div className="text-red-600">*</div>
                                Expire Date
                              </div>

                              <DatePicker
                                className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                                selected={selectdApp[obj.code]?.endDate}
                                onChange={(date: any) => {
                                  onValunChange(obj.code, "endDate", date);
                                }}
                                placeholderText="MM/DD/YYYY"
                                disabled={!selectdApp[obj.code]?.startDate}
                                minDate={selectdApp[obj.code]?.startDate}
                                required={true}
                              />
                              {selectdApp[obj.code]?.endDateError ? (
                                <div
                                  className={"text-xs text-[#FF0000] ml-2 flex"}
                                >
                                  {selectdApp[obj.code]?.endDateError}
                                </div>
                              ) : (
                                <div className={"text-xs text-[#FF0000] h-4"} />
                              )}
                            </div>
                          </div>
                        </div>
                        {obj.code === "COR-C" && <></>}
                        {obj.code === "COR-CU" && <></>}
                        {obj.code === "COR-L" && <></>}
                        {obj.code === "COR-A" && <></>}
                        {obj.code === "COR-P" && <></>}
                        {obj.code === "COR-K" && <></>}
                        {obj.code === "COR-R" && <></>}
                      </AccordionBody>
                    </Accordion>
                  );
                })}

              {/* <div className="grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 px-1 py-3 gap-4">
                <div />
                <div />
                {!application.appLoading ? (
                  <>
                    {application.appList.length < 8 && (
                      <Menu>
                        <MenuHandler>
                          <Button
                            className="  flex flex-row items-center  bg-[#264390]  p-2 h-[46px]"
                            size="sm"
                            // disabled={!isValidUserDetails()}
                            // // color="blue"
                            onClick={() => addApplication()}
                          >
                            <ChevronDownIcon className="w-7 h-7 mr-2 " />
                            <span className="text-[15px] font-normal">
                              Add Application Access
                            </span>
                          </Button>
                        </MenuHandler>

                        <MenuList
                          className={` p-0 w-[24%] relative  bg-[#264390] text-white boredr border-white rounded-none -mt-2 `}
                        >
                          {application.appList.map(
                            (menu: any, index: number) => (
                              <MenuItem
                                key={index}
                                className={`border-b border-white rounded-none 
                      ${
                        isSelected(menu.applicationCode) === -1
                          ? " "
                          : "bg-gray-200 text-gray-600 rounded-none "
                      }`}
                                onClick={() => onSelectOption(menu, "ADD")}
                              >
                                {menu.applicationName}
                              </MenuItem>
                            )
                          )}
                        </MenuList>
                      </Menu>
                    )}
                  </>
                ) : (
                  <MyLoader />
                )}
              </div>

              {applications.map((obj: any, index: number) => {
                let isError = false;
                let isCompleted = false;
                if (
                  selectdApp[obj.code]?.licenseError ||
                  selectdApp[obj.code]?.startDateError ||
                  selectdApp[obj.code]?.endDateError ||
                  selectdApp[obj.code]?.subscription_type_error
                ) {
                  isError = true;
                } else {
                  if (
                    selectdApp[obj.code]?.license &&
                    selectdApp[obj.code]?.startDate &&
                    selectdApp[obj.code]?.endDate &&
                    selectdApp[obj.code]?.subscription_type
                  ) {
                    isCompleted = true;
                  }
                }
                return (
                  <Accordion
                    open={open === index}
                    className="mb-2 rounded-lg border border-blue-gray-100 text-center shadow-xl "
                  >
                    <AccordionHeader
                      onClick={() => toggleHeader(index)}
                      className={`bg-[#264390] text-white ${
                        open == index
                          ? "rounded-lg rounded-b-none"
                          : "rounded-lg "
                      } h-[40px]  flex justify-between`}
                    >
                      <div className=" w-full flex flex-row justify-between items-center">
                        <div className="flex flex-row items-center">
                          <p className="mt-3 px-4">{obj.headerTitle}</p>
                          {isError && (
                            <ExclamationCircleIcon
                              className="w-8 h-8"
                              color={"#f2382e"}
                            />
                          )}
                          {isCompleted && (
                            <CheckBadgeIcon
                              className="w-8 h-8"
                              color={"#07e015"}
                            />
                          )}
                        </div>
                        <div className=" flex flex-row">
                          <div className="flex text-white">
                            <PencilSquareIcon className="w-8 h-8 mr-3 bg-[#264390] p-1" />
                            <TrashIcon
                              className="w-8 h-8 bg-[#264390] p-1"
                              onClick={() => onSelectOption(obj.id, "DELETE")}
                            />
                          </div>
                          <ChevronDownIcon className="w-8 h-8 ml-2 items-end" />
                        </div>
                      </div>
                    </AccordionHeader>
                    <AccordionBody className="pt-0 text-base font-normal bg-white">
                      <div className="flex flex-row w-full items-center">
                        <Image
                          className="px-3 py-2"
                          src={obj.logo}
                          width={180}
                          height={72}
                          alt="COR Advantage"
                        />

                        <div className="grid grid-cols-4 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-4 px-5 py-3 w-full ">
                          <TextInput
                            placeholder="Licence"
                            required={true}
                            value={selectdApp[obj.code]?.license}
                            crossOrigin={undefined}
                            type="number"
                            label="Licence"
                            error={selectdApp[obj.code]?.licenseError}
                            disabled={
                              (obj.code === "COR-C" && ccService.length > 0) ||
                              (obj.code === "COR-L" && llService.length > 0) ||
                              (obj.code === "COR-A" && caService.length > 0) ||
                              (obj.code === "COR-K" && ckService.length > 0) ||
                              (obj.code === "COR-CU" && cuService.length > 0) ||
                              (obj.code === "COR-P" && pqService.length > 0) ||
                              (obj.code === "COR-R" && rsService.length > 0)
                            }
                            onChange={(e: any) => {
                              applications[index].role = e.target.value;
                              setApplications([...applications]);

                              onValunChange(
                                obj.code,
                                "license",
                                e.target.value
                              );
                            }}
                          />
                          <div className="flex flex-col text-left">
                            <div className="w-full flex text-left">
                              <div className="text-red-600">*</div>
                              Start Date
                            </div>

                            <DatePicker
                              className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field"
                              selected={selectdApp[obj.code]?.startDate}
                              onChange={(date: any) => {
                                onValunChange(obj.code, "startDate", date);

                                const d = new Date(date);
                                d.setFullYear(d.getFullYear() + 1);
                                onValunChange(obj.code, "endDate", d);
                              }}
                              placeholderText="MM/DD/YYYY"
                              title={"Start Date"}
                              required={true}
                            />
                            {selectdApp[obj.code]?.startDateError ? (
                              <div className={"text-xs text-[#FF0000] flex"}>
                                {selectdApp[obj.code]?.startDateError}
                              </div>
                            ) : (
                              <div className={"text-xs text-[#FF0000] h-4"} />
                            )}
                          </div>

                          <div className="flex flex-col">
                            <div className="w-full flex ">
                              <div className="text-red-600">*</div>
                              Subscription Type
                            </div>
                            <div className="-mt-6 ">
                              <HSSelect
                                placeholder="Subscription Type*"
                                options={SUBSCRIPTION_TYPE}
                                getOptionLabel={(option: any) => option.label}
                                getOptionValue={(option: any) => option.value}
                                value={selectdApp[obj.code]?.subscription_type}
                                onChange={(obj: any) => {
                                }}
                                error={
                                  selectdApp[obj.code]?.subscription_type_error
                                }
                              />
                            </div>
                          </div>

                          <div className="w-[100%] flex flex-col">
                            <div className="w-full flex ">
                              <div className="text-red-600">*</div>
                              Expire Date
                            </div>

                            <DatePicker
                              className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                              selected={selectdApp[obj.code]?.endDate}
                              onChange={(date: any) => {
                                onValunChange(obj.code, "endDate", date);
                              }}
                              placeholderText="MM/DD/YYYY"
                              disabled={!selectdApp[obj.code]?.startDate}
                              minDate={selectdApp[obj.code]?.startDate}
                              required={true}
                            />
                            {selectdApp[obj.code]?.endDateError ? (
                              <div
                                className={"text-xs text-[#FF0000] ml-2 flex"}
                              >
                                {selectdApp[obj.code]?.endDateError}
                              </div>
                            ) : (
                              <div className={"text-xs text-[#FF0000] h-4"} />
                            )}
                          </div>
                        </div>
                      </div>
                      {obj.code === "COR-C" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addCCService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {ccService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-5 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-2 items-center `}
                            >
                              <div className="ml-4 mr-4 mt-3">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      !ccService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setCcService([...ccService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4 mt-3">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setCcService([...ccService]);
                                  }}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div>
                                  Start Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                                  selected={service.startDate}
                                  onChange={(date: any) => {
                                    service.startDate = date;
                                    service.startDateError = undefined;
                                    setCcService([...ccService]);
                                    const d = new Date(date);
                                    d.setFullYear(d.getFullYear() + 1);
                                    service.expireDate = d;
                                    service.expireDateError = undefined;
                                    setCcService([...ccService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  required={true}
                                />
                                {service?.startDateError ? (
                                  <div
                                    className={"text-xs text-[#FF0000] flex"}
                                  >
                                    {service?.startDateError}
                                  </div>
                                ) : (
                                  <div
                                    className={"text-xs text-[#FF0000] h-4"}
                                  />
                                )}
                              </div>
                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div>
                                  Expiry Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                                  selected={service.expireDate}
                                  onChange={(date: any) => {
                                    service.expireDate = date;
                                    service.expireDateError = undefined;
                                    setCcService([...ccService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  // disabled={!service.expireDate}
                                  // minDate={service.expireDate}
                                  required={true}
                                />
                                {service?.expireDateError ? (
                                  <div
                                    className={"text-xs text-[#FF0000] flex"}
                                  >
                                    {service?.expireDateError}
                                  </div>
                                ) : (
                                  <div
                                    className={"text-xs text-[#FF0000] h-4"}
                                  />
                                )}
                              </div>
                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deleteCCService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-CU" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addCUService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {cuService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-5 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-2 items-center`}
                            >
                              <div className="ml-4 mr-4 mt-3">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      !cuService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) || sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setCuService([...cuService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>

                              <div className="ml-4 mr-4 mt-3">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setCuService([...cuService]);
                                  }}
                                />
                              </div>

                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div> Start
                                  Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2 outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field"
                                  selected={service.startDate}
                                  onChange={(date: any) => {
                                    service.startDate = date;
                                    service.startDateError = undefined;
                                    setCuService([...cuService]);
                                    const d = new Date(date);
                                    d.setFullYear(d.getFullYear() + 1);
                                    service.expireDate = d;
                                    service.expireDateError = undefined;
                                    setCuService([...cuService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  required={true}
                                />
                                {service?.startDateError ? (
                                  <div className="text-xs text-[#FF0000] flex">
                                    {service?.startDateError}
                                  </div>
                                ) : (
                                  <div className="text-xs text-[#FF0000] h-4" />
                                )}
                              </div>

                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div> Expiry
                                  Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2 outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field"
                                  selected={service.expireDate}
                                  onChange={(date: any) => {
                                    service.expireDate = date;
                                    service.expireDateError = undefined;
                                    setCuService([...cuService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  required={true}
                                />
                                {service?.expireDateError ? (
                                  <div className="text-xs text-[#FF0000] flex">
                                    {service?.expireDateError}
                                  </div>
                                ) : (
                                  <div className="text-xs text-[#FF0000] h-4" />
                                )}
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize"
                                onClick={() => {
                                  deleteCUService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-L" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addLLService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {llService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols- md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-3 items-center `}
                            >
                              <div className="ml-4 mr-4">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      // Exclude already-selected service centers in other rows
                                      !llService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      // Always include the currently selected one for this row
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setLlService([...llService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  // error={nameError}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setLlService([...llService]);
                                  }}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div>
                                  Start Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                                  selected={service.startDate}
                                  onChange={(date: any) => {
                                    service.startDate = date;
                                    service.startDateError = undefined;
                                    setLlService([...llService]);
                                    const d = new Date(date);
                                    d.setFullYear(d.getFullYear() + 1);
                                    service.expireDate = d;
                                    service.expireDateError = undefined;
                                    setLlService([...llService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  // disabled={!service.startDate}
                                  // minDate={service.startDate}
                                  required={true}
                                />
                                {service?.startDateError ? (
                                  <div
                                    className={"text-xs text-[#FF0000] flex"}
                                  >
                                    {service?.startDateError}
                                  </div>
                                ) : (
                                  <div
                                    className={"text-xs text-[#FF0000] h-4"}
                                  />
                                )}
                              </div>
                              <div className="ml-4 mr-4">
                                <div className="w-full flex text-left">
                                  <div className="text-red-600">*</div>
                                  Expiry Date
                                </div>
                                <DatePicker
                                  className="border-2 w-full h-[45px] px-2  outline-blue-500 border-[#264390] rounded-lg bg-transparent undefined required-field "
                                  selected={service.expireDate}
                                  onChange={(date: any) => {
                                    service.expireDate = date;
                                    service.expireDateError = undefined;
                                    setLlService([...ccService]);
                                  }}
                                  placeholderText="MM/DD/YYYY"
                                  // disabled={!service.expireDate}
                                  // minDate={service.expireDate}
                                  required={true}
                                />
                                {service?.expireDateError ? (
                                  <div
                                    className={"text-xs text-[#FF0000] flex"}
                                  >
                                    {service?.expireDateError}
                                  </div>
                                ) : (
                                  <div
                                    className={"text-xs text-[#FF0000] h-4"}
                                  />
                                )}
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deleteLLService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-A" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addCAService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {caService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-3 items-center `}
                            >
                              <div className="ml-4 mr-4">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      // Exclude already-selected service centers in other rows
                                      !caService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      // Always include the currently selected one for this row
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setCaService([...caService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  // error={nameError}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setCaService([...caService]);
                                  }}
                                />
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deleteCAService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-P" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addPQService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {pqService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-3 items-center `}
                            >
                              <div className="ml-4 mr-4">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      // Exclude already-selected service centers in other rows
                                      !pqService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      // Always include the currently selected one for this row
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setPqService([...pqService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  // error={nameError}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setPqService([...pqService]);
                                  }}
                                />
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deletePQService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-K" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addCKService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {ckService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-3 items-center `}
                            >
                              <div className="ml-4 mr-4">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      // Exclude already-selected service centers in other rows
                                      !ckService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      // Always include the currently selected one for this row
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setCkService([...ckService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  // error={nameError}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setCkService([...ckService]);
                                  }}
                                />
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deleteCKService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {obj.code === "COR-R" && (
                        <div className="px-4 pb-28">
                          <div className="">
                            <Button
                              className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md"
                              onClick={() => addRSService()}
                            >
                              <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                + Add Service Center (Level 2)
                              </span>
                            </Button>
                          </div>

                          {rsService?.map((service, index) => (
                            <div
                              key={index}
                              className={`${
                                service.isDelete ? "opacity-40" : ""
                              }  border border-[#264390] bg-[#ececec] mt-3 grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-3 items-center `}
                            >
                              <div className="ml-4 mr-4">
                                <HSSelect
                                  label="Service Center"
                                  placeholder="Select Service Center"
                                  required={true}
                                  options={serviceCenters.filter(
                                    (sc: any) =>
                                      // Exclude already-selected service centers in other rows
                                      !rsService.some(
                                        (s, idx) =>
                                          idx !== index &&
                                          s.globalServiceId === sc.id
                                      ) ||
                                      // Always include the currently selected one for this row
                                      sc.id === service.globalServiceId
                                  )}
                                  getOptionLabel={(option: any) => option.name}
                                  getOptionValue={(option: any) => option.id}
                                  value={
                                    serviceCenters.find(
                                      (sc: any) =>
                                        sc.id === service.globalServiceId
                                    ) || null
                                  }
                                  onChange={(selected: any) => {
                                    service.globalServiceId = selected
                                      ? selected.id
                                      : undefined;
                                    service.serviceCenterName = selected
                                      ? selected.name
                                      : "";
                                    service.name_error = undefined;
                                    setRsService([...rsService]);
                                  }}
                                  error={service.name_error}
                                  disabled={!service.isActive}
                                />
                              </div>
                              <div className="ml-4 mr-4">
                                <TextInput
                                  placeholder="Number of Licences"
                                  required={true}
                                  crossOrigin={undefined}
                                  type="number"
                                  label="Licence"
                                  disabled={service.isDelete}
                                  error={service.licenseError}
                                  value={service.licenceNumber}
                                  // error={nameError}

                                  onChange={(e: any) => {
                                    service.licenceNumber = e.target.value;
                                    service.licenseError = undefined;
                                    setRsService([...rsService]);
                                  }}
                                />
                              </div>

                              <Button
                                className="flex flex-row items-center justify-center m-4 bg-[#264390] hover:bg-gray-500 py-3 px-5 2xl:px-4 2xl:py-3 rounded-md !capitalize "
                                onClick={() => {
                                  deleteRSService(service);
                                }}
                              >
                                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                                  {" "}
                                  Delete
                                </span>
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </AccordionBody>
                  </Accordion>
                );
              })} */}
            </div>

            <div
              className={`flex justify-end px-5 border-t-2 border-gray-400 py-3 h-[60px]`}
            >
              <Button
                className="flex flex-row items-center justify-center bg-[#264390] hover:bg-gray-500 py-3 px-3 2xl:px-4 2xl:py-3 rounded-md"
                onClick={() => onSubmit()}
              >
                <span className="text-[15px] 2xl:text-[18px] font-semibold hover:text-[#264390]">
                  {" "}
                  Register
                </span>
              </Button>
            </div>
          </div>
        </div>
      </Container>
      {/* ) : null}
      </AuthenticatedTemplate> */}

      <HSDialog
        header={"Error"}
        message="Please select at least one application"
        handleOpen={(message: any) => showAlertDialog(message)}
        open={alertDialog}
        size={"xs"}
      />
    </>
  );
};
